import FieldButton from '@/features/ui/buttons/components/FieldButton'
import Dropdown from '@/features/ui/components/Dropdown'
import { DropdownContentWidth } from '@/features/ui/components/Dropdown/types'
import { FC, ReactNode } from 'react'
import { StyleProp, ViewStyle } from 'react-native'

export interface DropdownControlProps {
    children: ReactNode
    open: boolean
    disabled?: boolean
    label: string
    value: string
    placeholder: string
    onToggleOpen: () => void
    alignFrontIconToLabel?: boolean
    FrontIcon?: ReactNode
    TailIcon?: ReactNode
    ActiveTailIcon?: ReactNode
    containerStyle?: StyleProp<ViewStyle>
    contentWidth?: DropdownContentWidth
    style?: StyleProp<ViewStyle>
}

const DropdownControl: FC<DropdownControlProps> = ({
    children,
    open,
    disabled,
    label,
    value,
    placeholder,
    onToggleOpen,
    alignFrontIconToLabel,
    FrontIcon,
    TailIcon,
    ActiveTailIcon,
    containerStyle,
    contentWidth = 'anchor',
    style,
}) => {
    const TailIconComponent = open && ActiveTailIcon ? ActiveTailIcon : TailIcon

    return (
        <Dropdown
            contentWidth={contentWidth}
            visible={open}
            Anchor={
                <FieldButton
                    active={open}
                    disabled={disabled}
                    label={label}
                    value={value}
                    placeholder={placeholder}
                    onPress={onToggleOpen}
                    alignFrontIconToLabel={alignFrontIconToLabel}
                    FrontIcon={FrontIcon}
                    TailIcon={TailIconComponent}
                    style={style}
                />
            }
            ItemList={children}
            onClose={onToggleOpen}
            containerStyle={containerStyle}
        />
    )
}

export default DropdownControl
